import React from 'react';
import { ContentElementCompanyLogo as CeCompanyLogo } from '@vgn-medien-holding/vgn-fe-components';
import { ContentElementCompanyLogo as ContentElementCompanyLogoType } from '@src/lib/graphql/generated';
import elementStyle from './styles/default';

export default function ContentElementCompanyLogo(element: ContentElementCompanyLogoType) {
  return <CeCompanyLogo element={element} classProps={elementStyle} />;
}
